export default __webpack_public_path__ + "static/media/luann-avatar-ocdc.15e0f4e7.png";